import React from 'react';
import { Typography } from 'antd';
import { LogoOrInitials } from '../hero/LogoOrInitials';

interface Props {
  id: number;
  displayName: string;
  photoUrl: string | null;
  bio?: string | null;
  onClick: (id: number, displayName: string) => void;
}

export const SpecialistCard: React.FC<Props> = React.memo(({ id, displayName, photoUrl, bio, onClick }) => (
  <button
    type="button"
    onClick={() => onClick(id, displayName)}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 6,
      padding: '8px 12px',
      minWidth: 80,
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      WebkitTapHighlightColor: 'transparent',
    }}
  >
    <LogoOrInitials name={displayName} logoUrl={photoUrl} size={48} />
    <Typography.Text
      style={{ fontSize: 12, textAlign: 'center', maxWidth: 80, color: 'var(--bl-text)' }}
      ellipsis={{ tooltip: displayName }}
    >
      {displayName}
    </Typography.Text>
    {bio && (
      <Typography.Text
        type="secondary"
        style={{ fontSize: 11, textAlign: 'center', maxWidth: 80 }}
        ellipsis={{ tooltip: bio }}
      >
        {bio}
      </Typography.Text>
    )}
  </button>
));

SpecialistCard.displayName = 'SpecialistCard';
